import { createClient } from '@supabase/supabase-js';

// Obtiene las variables desde tu archivo .env
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_ANON_KEY;

// Crea el cliente
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
